import { render, staticRenderFns } from "./FamilyBackgroundInfoItem.vue?vue&type=template&id=334ed694&"
import script from "./FamilyBackgroundInfoItem.vue?vue&type=script&lang=js&"
export * from "./FamilyBackgroundInfoItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports